<template>
  <b-container>
    <b-card class="mt-3" style="margin-bottom:100px;">
      <app-head />
      <b-row>
        <b-col>
          <app-fragebogen />
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Fragebogen from "@/components/Fragebogen.vue";
import Head from "@/components/Head.vue";

export default {
  name: "Fragebogen",
  components: {
    appFragebogen: Fragebogen,
    appHead: Head,
  },
};
</script>
